export const CARET_SIZE = 24;
export const PRODUCT_LINKS = {
    appIntegrations: {
        text: 'App integrations',
        description: 'Explore 5,000+ app connections',
        href: '/apps',
    },
    earlyAccessProgram: {
        text: 'Zapier Early Access',
        href: '/early-access',
    },
    features: {
        text: 'Features',
        description: 'Build flexible workflows',
        href: '/features',
    },
    howItWorks: {
        text: 'How it works',
        description: 'Learn the basics',
        href: '/how-it-works',
    },
    security: {
        text: 'Security',
        description: 'Trusted by 2M+ businesses',
        href: '/security',
    },
    zapierTables: {
        text: 'Tables',
        href: '/tables',
        icon: 'navTable',
        description: 'No-code databases built for Zaps',
        tag: 'beta',
    },
    aiChatbot: {
        text: 'AI Chatbot',
        href: '/ai/chatbot',
        icon: 'miscAiChatbot',
        description: 'Easy to build, no code required',
        tag: 'beta',
    },
    zapierInterfaces: {
        text: 'Interfaces',
        href: '/interfaces',
        icon: 'navInterfaces',
        description: 'Custom pages to power your Zaps',
        tag: 'beta',
    },
};
export const SIDEBAR_PRODUCT_MENU = {
    text: 'Product',
    href: null,
    submenu: [
        {
            text: PRODUCT_LINKS.howItWorks.text,
            href: PRODUCT_LINKS.howItWorks.href,
        },
        {
            text: PRODUCT_LINKS.security.text,
            href: PRODUCT_LINKS.security.href,
        },
        {
            text: PRODUCT_LINKS.features.text,
            href: PRODUCT_LINKS.features.href,
        },
        {
            text: PRODUCT_LINKS.appIntegrations.text,
            href: PRODUCT_LINKS.appIntegrations.href,
        },
        {
            text: PRODUCT_LINKS.earlyAccessProgram.text,
            href: PRODUCT_LINKS.earlyAccessProgram.href,
            submenu: [
                {
                    text: `${PRODUCT_LINKS.zapierTables.text} (beta)`,
                    href: PRODUCT_LINKS.zapierTables.href,
                },
                {
                    text: `${PRODUCT_LINKS.zapierInterfaces.text} (beta)`,
                    href: PRODUCT_LINKS.zapierInterfaces.href,
                },
                {
                    text: `${PRODUCT_LINKS.aiChatbot.text} (beta)`,
                    href: PRODUCT_LINKS.aiChatbot.href,
                },
            ],
        },
    ],
};
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@8.3.7 (9c955f548)
